import { forwardRef } from "react";
import { useSelector } from "react-redux";
import theme from "../../config/theme";

interface buttonProps {
  title: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  type?: "button" | "submit" | "reset";
  variant?: "success" | "edit" | "delete" | "info";
  backgroundColor?: string;
  color?: string;
  borderColor?: string;
  borderRadius?: number;
  disabled?: boolean;
  icon?: React.ReactNode;
  bgColor?: string;
  paddingy?: string;
  paddingx?: string;
}

const Button = forwardRef<HTMLButtonElement, buttonProps>((props, ref) => {
  const {
    type = "button",
    variant,
    title,
    color,
    icon,
    bgColor,
    onClick,
    disabled,
    paddingx,
    paddingy,
    ...others
  } = props;
  const { theme: themeMode } = useSelector((state: any) => state.globalState);
  const mode = themeMode === "light" ? theme.light : theme.dark;
  return (
    <button
      ref={ref}
      onClick={onClick}
      className={`flex justify-end items-center rounded px-5 py-2 text-xs h-[38px] hover:shadow-[0_0px_4px_#03797d73] transition delay-100 duration-200 ease-in-out`}
      disabled={disabled}
      type={type}
      style={{
        backgroundColor:
          variant === "success"
            ? mode.backgroundColor.bgSuccess
            : variant === "delete"
            ? mode.backgroundColor.bgDanger
            : variant === "edit"
            ? mode.backgroundColor.bgWarning
            : variant === "info"
            ? mode.backgroundColor.bgInfo
            : bgColor,
        color:
          variant === "success"
            ? mode.color.textSuccess
            : variant === "delete"
            ? mode.color.textDanger
            : variant === "edit"
            ? mode.color.textWarning
            : variant === "info"
            ? mode.color.textInfo
            : color,

        paddingRight: paddingx,
        paddingLeft: paddingx,
        paddingTop: paddingy,
        paddingBottom: paddingy,

        ...others,
      }}
    >
      {icon && <span>{icon}</span>}
      {title}
    </button>
  );
});

export default Button;
